import React from 'react';
import PropTypes from 'prop-types'
import '../OfficesPage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import DateTime from '../../../components/library/common/DateTime';

const OfficesLastUpdated = () => {    
    return (
        <div className='columns'>
            <div className='column is-8 homePageHeader' >
                <div>
                    <p>
                        <HrbTranslate text='OfficesPage.Labels.LastUpdated' /><b><DateTime value={new Date().toUTCString()} dateAndTime /></b>
                    </p>
                </div>
            </div>
        </div>
    )
}

OfficesLastUpdated.propTypes = {
    fileTimeDays: PropTypes.number
}

export default OfficesLastUpdated